import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-e-ticketing-form',
  templateUrl: './e-ticketing-form.component.html',
  styleUrls: ['./e-ticketing-form.component.scss']
})
export class ETicketingFormComponent implements OnInit {

    bearer;
    feedback = [];
    body = [];
    topic_id;
    messagesForm: FormGroup;

    imagePath: any;
    imgURL: any;
    imgId: any;
    message: string;

    errorMsg = "";

    store_id;
    title;
    caption;
    filesize;
    alt_text;

    showloader = false;
    chooseTopic = true;


    buildForm() {
      this.messagesForm = this.formBuilder.group({
        message: [''],
        topic_id: [''],
      });

    }

    constructor(
      private svc: StoreService,
      private router: Router,
      private formBuilder: FormBuilder,
      private modalService: NgbModal,
      private location: Location,
      public utils: UtilitiesService,
    ) { }

    ngOnInit(): void {
      this.bearer = localStorage.getItem('bearer');
      this.store_id = localStorage.getItem('store_id');
      this.messagesForm = this.formBuilder.group({
        message: ['',[Validators.required,Validators.minLength(5)]],
        topic_id: ['',Validators.required],
      });
      this.ionViewDidEnter()
    }

    ionViewDidEnter() {
        this.svc.getFeedbackTopic(this.bearer).subscribe(res => {

          this.feedback = res['data'];
          this.topic_id = res['data']['feedback_topic_id'];
          console.log(this.feedback);
        })
      }

      selectTopic(topic:any , topic_id:any){
        //this.topic_id =
      }

      preview(files: any) {
        if (files.length === 0) {
            return;
        }

        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
            this.imgURL = reader.result;
        }
    }

      messagesTopic(){
        this.body = this.messagesForm.value['topic_id'];
        console.log(this.body);

        this.svc.createFeedback(this.messagesForm.value['topic_id'],this.messagesForm.value['message'] , this.imgId, this.bearer).subscribe(
          data => {
            console.log('submit done');
            //this.createMedia();
          this.utils.notify.showSuccess(this.utils.translate("Create Successfully!"));
            setTimeout(() => {
               this.router.navigate(['/dashboard/e-ticketing-list']);
            }, 3000)

          },
          error => {
            console.log(error);

            this.errorMsg = error['error']['message'];
            console.log(this.errorMsg);

            this.utils.notify.showError(this.utils.translate("Create Failed! ")+ error?.error?.message?.message);
          },
        );
      }

      createMedia(){
        this.svc.createMedia(this.store_id, this.title, this.caption,this.alt_text,this.filesize,this.imgURL ,this.bearer).subscribe(res =>{
          console.log('done create media');
          console.log(res);
        })
      }

      open() {
        const modalRef = this.modalService.open(UploadImageComponent,{ size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.id = 10;
        modalRef.result.then((result) => {
          if(result != 'Modal Closed'){
            //this.title = '';
            //this.caption = '';
            //this.alt_text = '';
            //this.filesize = result[1];
            this.imgURL = result[0];
            this.imgId = result[1];
          }
        }).catch((error) => {
          console.log(error);
        });
      }

      removeImage() {
        this.imgURL = '';
        this.imgId = '';
      }
  }
